import { HttpClient } from "@angular/common/http";
import { Endpoints } from "src/app/shared/config/endpoints";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/app.state";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FacebookService {
  private orgId: number;
  private baseUri = this.endpoints.facebookServiceUrl;

  postToView = new BehaviorSubject<any>({});
  postToReply: any = new BehaviorSubject<any>({});
  repliedPost: any = new BehaviorSubject<string>("");

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.orgId = info.organization.id;
    });
  }

  fetchOrganizationPages(): Observable<any> {
    return this.http.get(`${this.baseUri}/pages/${this.orgId}`);
  }

  login(code: string): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/setup/connect`, {
      code,
      org_id: this.orgId,
    });
  }

  subscribeToApp(data: any): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/setup/subscribe`, {
      org_id: this.orgId,
      ...data,
    });
  }

  fetchPageSubscriptions(pageId: any): Observable<any> {
    return this.http.get(
      `${this.baseUri}/pages/setup/subscriptions/${this.orgId}/${pageId}`
    );
  }

  updateOrganizationPages(data: any): Observable<any> {
    return this.http.put(
      `${this.baseUri}/pages/active/${this.orgId}/${data.id}`,
      { ...data }
    );
  }

  disconnectOrganizationPage(pageId: any): Observable<any> {
    return this.http.delete(
      `${this.baseUri}/pages/setup/disconnect/${this.orgId}`
    );
  }

  fetchOrganizationPagePosts(pageId: any): Observable<any> {
    return this.http.get(
      `${this.baseUri}/feeds/read/filter?orgId=${this.orgId}&pageId=${pageId}`
    );
  }

  fetchOrganizationPageAnalytics(pageId: any): Observable<any> {
    return this.http.get(
      `${this.baseUri}/pages/analytics/${this.orgId}/${pageId}`
    );
  }

  fetchFacebookPost(pageId: any, postId: any): Observable<any> {
    return this.http.get(
      `${this.baseUri}/pages/facebook-post/${this.orgId}/${pageId}/${postId}`
    );
  }

  replyComment(data: any): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/response/comment`, {
      ...data,
      org_id: this.orgId,
    });
  }

  replyPost(data: any): Observable<any> {
    return this.http.post(`${this.baseUri}/pages/response/post`, {
      ...data,
      org_id: this.orgId,
    });
  }
}
